import VerifyCamera from './VerifyCamera';

export default VerifyCamera;
